<template>
    <div v-if="value.cadastro">
        <az-sub-title :title="is_vtr ? 'Primeira Vez' : 'Paciente Primeira Vez'" />
        <div class="row" v-if="value.cadastro && direto">
            <div class="col col-12 col-md-6">
                <az-input
                    :label="is_vtr ? 'Nome do Animal' : 'Nome do Paciente'"
                    v-model="value.st_nome" />
            </div>
            <div class="col col-12 col-md-3">
                <az-input 
                    label="Sexo" 
                    type="sexo" 
                    v-model="value.cadastro.ch_sexo" />
            </div>
            <div class="col col-12 col-md-3">
                <az-input 
                    label="Data de Nascimento" 
                    type="date" 
                    v-model="value.cadastro.dt_nascimento"
                    :validate="validate" 
                    :rules="['nasc']">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="idade || idade === 0">
                            <span class="input-group-text" id="basic-addon2" title="Idade em anos">{{ idade }}a</span>
                        </div>
                    </template>
                </az-input>
            </div>
        </div>

        <div class="row" v-if="value.cadastro && !is_vtr">
            <div class="col col-12 col-md-6" id="primeiro-campo">
                <az-input 
                    @input="entrar_cpf()"
                    :edicao="!value.cadastro.fl_estrangeiro" 
                    label="CPF" 
                    type="cpf" 
                    v-model="value.cadastro.st_cpf" 
                    required 
                    :validate="validate" :rules="['cpf']" />
            </div>
            <div class="col col-12 col-md-3" v-if="!value.cadastro.st_cpf">
                <small class="form-text text-muted text-nowrap text-truncate">
                    &nbsp;
                </small>
                <az-input
                    type="checkbox-group" 
                    :label="( value.cpf_nao_obrigatorio || ( value.st_nome && value.st_nome.slice(0,3) == 'RN ' ) || idade === 0 || ( idade && idade < 18 ) ) ? 'CPF não apresentado' : 'Estrangeiro sem CPF'" 
                    v-model="value.cadastro.fl_estrangeiro"
                    @input="verificar_sem_cpf()" />
            </div>
            <div class="col col-12 col-md-3" v-if="$store.state.user.st_login == 'administrador'">
                <small class="form-text text-muted text-nowrap text-truncate">
                    Gerar
                </small>
                <button type="button" class="btn btn-outline-primary" @click="gerarCpf()">
                    <i class="fas fa-paint-brush"></i>
                </button>
            </div>
        </div>

        <div class="row" v-if="value.cadastro && !direto">
            <div class="col col-12 col-md-6">
                <az-input
                    :label="is_vtr ? 'Nome do Animal' : 'Nome do Paciente'"
                    :edicao="false"
                    v-model="value.st_nome" />
            </div>
            <div class="col col-12 col-md-3">
                <az-input 
                    :edicao="value.cadastro.edit_dn" 
                    label="Sexo" 
                    type="sexo" 
                    v-model="value.cadastro.ch_sexo" />
            </div>
            <div class="col col-12 col-md-3">
                <az-input 
                    :edicao="value.cadastro.edit_dn" 
                    label="Data de Nascimento" 
                    type="date" 
                    v-model="value.cadastro.dt_nascimento"
                    :validate="validate" 
                    :rules="['nasc']">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="idade || idade === 0">
                            <span class="input-group-text" id="basic-addon2" title="Idade em anos">{{ idade }}a</span>
                        </div>
                    </template>
                </az-input>
            </div>
        </div>

        <div class="row" v-if="!direto && value.cadastro && value.cadastro.fl_estrangeiro">
            <div class="col col-12 col-md-6">
                <az-input
                    :edicao="false"
                    label="e-mail"
                    v-model="value.cadastro.st_email" />
            </div>
            <div class="col col-12 col-md-3" v-if="value.cadastro.telefones">
                <az-input
                    :edicao="false" 
                    label="Telefone" 
                    type="fone" 
                    v-model="value.cadastro.telefones.telefone" />
            </div>
            <div class="col col-12 col-md-3" v-if="value.cadastro.telefones">
                <az-input
                    :edicao="false" 
                    label="Celular" 
                    type="fone" 
                    v-model="value.cadastro.telefones.celular"
                    :validate="validate" />
            </div>
        </div>

        <div class="row" v-if="!direto && !sus_block_obrig && value.cadastro && value.cadastro.fl_estrangeiro && value.paciente_unidade && value.paciente_unidade.plano && value.paciente_unidade.plano.operadora && value.paciente_unidade.plano.operadora.fl_sus">
            <div class="col col-12 col-md-6">
                <az-input 
                    @input="entrar_cpf()"
                    label="Cartão SUS"
                    required
                    type="cns" 
                    v-model="value.paciente_unidade.st_sus" 
                    :validate="validate"
                    :rules="['size:15']">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="value.paciente_unidade.st_sus">
                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="copiar_clipboard(value.paciente_unidade.st_sus)" title="Copiar">
                                <i class="fa-solid fa-copy"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
        </div>

        <div class="mt-3" v-if="!direto && value.cadastro && value.cadastro.fl_estrangeiro ">
            <az-input
                :placeholder="'Informe o nome do ' + ( is_vtr ? 'animal' : 'paciente' ) + ' para buscar cadastro prévio...'"
                icon="fas fa-user"
                type="autocomplete"
                optionsMode="aql"
                service="pacientes.index"
                optionsDisplay="search"
                ref="info_paciente"
                v-model="value.novo_paciente"
                :optimized_ac="true"
                @input="selecionarPaciente()" />
        </div>

        <div class="mt-3" v-if="lista && lista.length > 0">
            <az-sub-title title="Paciente já cadastrado" />
            <div class="list-group">
                <button type="button" class="list-group-item list-group-item-action" v-for="(item, idx) in lista" :key="idx"
                    @click="selecionar(item)">
                    {{ item.pessoa.st_nome }}, {{ item.sexo }}, {{ item.idade }}, CPF: {{ item.st_cpf }}
                </button>
            </div>
        </div>

        <div class="mt-3" v-if="( ( value.cadastro && ( value.cadastro.idade_anos < 18 || value.cadastro.fl_estrangeiro || ( idade !== null && idade < 18 ) ) ) 
            || ( lista && !lista.length && value.cadastro && value.cadastro.st_cpf && value.cadastro.st_cpf.length == 11 ) )">
            <div class="list-group">
                <button type="button" id="botao-incluir-paciente" class="list-group-item list-group-item-action active" @click="incluir()">
                    Incluir {{ is_vtr ? 'Animal' : 'Paciente' }}
                </button>
            </div>
        </div>

        <div v-if="!direto && value.cadastro && !value.cadastro.st_cpf && marcacao && !marcacao.id_atendimento && marcacao.js_outros_campos && marcacao.js_outros_campos.senha_ch == value.st_nome" class="mt-5">
            <button type="button" class="btn btn-danger" :disabled="$store.state.loading" @click="cancelar_senha()">Cancelar Senha: {{ marcacao.js_outros_campos.senha_ch }}</button>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import * as moment from "moment";
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {

    data() { 
        return { 
            lista: [],
            validate: false, 
        }
    },

    value: {
        handler() {
            this.$emit('input', this.value);
        },
        deep: true,
        immediate: true,
    },

    props: ['value', 'direto', 'sus_block_obrig', 'marcacao'],

    components: { 
        AzInput,
        AzSubTitle,
    },

    computed: 
    { 
        is_vtr: function () { 
            return this.$store.state.user && this.$store.state.user.vtr;
        },

        idade: function () { 
            if ( !this.value || !this.value.cadastro || !this.value.cadastro.dt_nascimento )
                return null;

            let today = moment();
            let birthdateMoment = moment(this.value.cadastro.dt_nascimento, 'YYYY-MM-DD');
            
            return today.diff(birthdateMoment, 'years');
        }
    },

    mounted() { 
        this.validate = false;
    },

    methods: { 
        cancelar_senha () { 
            if ( !confirm('Confirma o cancelamento da senha?' ) ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'agendas', 
                func: 'destroy',
                no_validate: true, 
                dados: { 
                    id: this.marcacao.id_marcacao,
                    motivo: 'Cancelamento de senha',
                },
                callback: () => { 
                    this.$emit('refresh');
                    $('.modal').modal('hide');
                }
            });
        },

        selecionarPaciente () { 
            if ( !this.value || !this.value.novo_paciente )
                return;

            this.selecionar(this.value.novo_paciente);

            this.$nextTick(() => { 
                this.value.novo_paciente = "";
            });
        },

        gerarCpf() {
            const num1 = this.aleatorio(); 
            const num2 = this.aleatorio();
            const num3 = this.aleatorio();

            const dig1 = this.dig(num1, num2, num3); 
            const dig2 = this.dig(num1, num2, num3, dig1); 

            this.value.cadastro.st_cpf = `${num1}${num2}${num3}${dig1}${dig2}`;
            this.value.paciente_unidade.st_numero_carteira = this.aleatorio(4);
            this.value.paciente_unidade.dt_validade_carteira = '2030-06-01';

            this.$nextTick(() => { 
                this.entrar_cpf();
            });
        },

        dig(n1, n2, n3, n4) { 
            
            let nums = n1.split("").concat(n2.split(""), n3.split(""));
            
            if (n4){ 
                nums[9] = n4;
            }
            
            let x = 0;
            
            for (let i = (n4 ? 11:10), j = 0; i >= 2; i--, j++) {
                x += parseInt(nums[j]) * i;
            }
            
            const y = x % 11;

            return y < 2 ? 0 : 11 - y; 
        },

        aleatorio(size = 3) {
            const aleat = Math.floor(Math.random() * ( Math.pow(10,size) - 1 ) );
            return ("" + aleat).padStart(3, '0'); 
        },

        incluir () { 
            this.$emit('selecionado');

            this.value.sinalizadores = [];
            this.value.verificado = true;
            this.value.cadastro.st_raca = this.value.st_raca ? this.value.st_raca : "";
            this.value.cadastro.st_etnia = "";

            setTimeout(() => {
                if ( $('#primeiro-campo input').length ) { 
                    $('#primeiro-campo input')[0].focus();
                }
            }, 100);
        },

        selecionar (paciente) { 
            
            this.$util.loadItem(this, { 
                service: 'pacientes',
                func: 'show',
                parms: { 
                    id: paciente.id_pessoa,
                }
            }) 
            .then(dados => { 
                let campos = [
                    { 
                        id: 'st_nome',
                        label: "Nome",
                        origem: dados.st_nome,
                        value: ( this.value.st_nome != dados.st_nome && !this.value.st_nome.match(/\d+/g) ) ? this.value.st_nome : null,
                        type: 'text', 
                        selec: false, 
                    },
                    { 
                        id: 'st_nome_social',
                        label: "Nome Social",
                        origem: dados.st_nome_social,
                        value: this.value.st_nome_social != dados.st_nome_social ? this.value.st_nome_social : null,
                        type: 'text', 
                        selec: false, 
                    },
                    { 
                        id: 'cadastro.st_nome_mae',
                        label: "Nome da Mãe",
                        origem: dados.cadastro.st_nome_mae,
                        value: this.value.cadastro.st_nome_mae != dados.cadastro.st_nome_mae ? this.value.cadastro.st_nome_mae : null,
                        type: 'text', 
                        selec: false, 
                    },
                    { 
                        id: 'cadastro.dt_nascimento',
                        label: "Data de Nascimento",
                        origem: dados.cadastro.dt_nascimento,
                        value: ( this.value.cadastro.dt_nascimento != dados.cadastro.dt_nascimento && this.value.cadastro.dt_nascimento > '1900-01-01' ) ? this.value.cadastro.dt_nascimento : null,
                        type: 'date', 
                        selec: false, 
                    },
                    { 
                        id: 'cadastro.telefones.telefone',
                        label: "Telefone",
                        origem: dados.cadastro.telefones.telefone, 
                        value: this.value.cadastro.telefones.telefone != dados.cadastro.telefones.telefone ? this.value.cadastro.telefones.telefone : null,
                        type: 'fone', 
                        selec: false, 
                    },
                    { 
                        id: 'cadastro.telefones.celular',
                        label: "Celular",
                        origem: dados.cadastro.telefones.celular, 
                        value: this.value.cadastro.telefones.celular != dados.cadastro.telefones.celular ? this.value.cadastro.telefones.celular : null,
                        type: 'fone', 
                        selec: false, 
                    },
                    { 
                        id: 'cadastro.st_email',
                        label: "E-mail",
                        origem: dados.cadastro.st_email, 
                        value: this.value.cadastro.st_email != dados.cadastro.st_email ? this.value.cadastro.st_email : null,
                        type: 'text', 
                        selec: false, 
                    },
                    { 
                        id: 'cadastro.st_rg',
                        label: "RG",
                        origem: dados.cadastro.st_rg,
                        value: this.value.cadastro.st_rg != dados.cadastro.st_rg ? this.value.cadastro.st_rg : null,
                        type: 'text', 
                        selec: false,   
                    },
                    { 
                        id: 'paciente_unidade.st_numero_carteira',
                        label: "Número da Matrícula",
                        origem: dados.paciente_unidade.st_numero_carteira,
                        value: this.value.paciente_unidade.st_numero_carteira != dados.paciente_unidade.st_numero_carteira ? this.value.paciente_unidade.st_numero_carteira : null,
                        type: 'text', 
                        selec: false,   
                    },
                    { 
                        id: 'paciente_unidade.dt_validade_carteira',
                        label: "Validade da Matrícula",
                        origem: dados.paciente_unidade.dt_validade_carteira,
                        value: this.value.paciente_unidade.dt_validade_carteira != dados.paciente_unidade.dt_validade_carteira ? this.value.paciente_unidade.dt_validade_carteira : null,
                        type: 'date', 
                        selec: false,   
                    },
                    { 
                        id: 'cadastro.endereco.in_cep',
                        label: "CEP",
                        origem: dados.cadastro.endereco.in_cep,
                        value: this.value.cadastro.endereco.in_cep != dados.cadastro.endereco.in_cep ? this.value.cadastro.endereco.in_cep : null,
                        type: 'cep', 
                        selec: false,   
                    },
                    { 
                        id: 'cadastro.endereco.st_logradouro',
                        label: "Logradouro",
                        origem: dados.cadastro.endereco.st_logradouro,
                        value: this.value.cadastro.endereco.st_logradouro != dados.cadastro.endereco.st_logradouro ? this.value.cadastro.endereco.st_logradouro : null,
                        type: 'text', 
                        selec: false,   
                    },
                    { 
                        id: 'cadastro.endereco.st_complemento',
                        label: "Complemento do Endereço",
                        origem: dados.cadastro.endereco.st_complemento,
                        value: this.value.cadastro.endereco.st_complemento != dados.cadastro.endereco.st_complemento ? this.value.cadastro.endereco.st_complemento : null,
                        type: 'text', 
                        selec: false,   
                    },
                    { 
                        id: 'cadastro.endereco.st_numero',
                        label: "Número do Endereço",
                        origem: dados.cadastro.endereco.st_numero,
                        value: this.value.cadastro.endereco.st_numero != dados.cadastro.endereco.st_numero ? this.value.cadastro.endereco.st_numero : null,
                        type: 'text', 
                        selec: false,   
                    },
                    { 
                        id: 'cadastro.endereco.st_bairro',
                        label: "Bairro",
                        origem: dados.cadastro.endereco.st_bairro,
                        value: this.value.cadastro.endereco.st_bairro != dados.cadastro.endereco.st_bairro ? this.value.cadastro.endereco.st_bairro : null,
                        type: 'text', 
                        selec: false,   
                    }
                ];

                campos = campos.filter(c => c.value)
                    .map(c => { 
                        if ( !c.origem ) { 
                            c.selec = true; 
                        }

                        return c;
                    });

                dados.info_origem = campos;
                dados.verificado = true; 

                this.$emit('input', dados);
            });

        },

        verificar_sem_cpf () { 

            if ( this.value.cadastro.fl_estrangeiro ) { 

                this.$store.commit('loading', true);        

                this.$util.loadItem(this, { 
                    service: "pacientes",
                    func: "checar_existencia",
                    parms: { 
                        dt_nascimento: this.value.cadastro.dt_nascimento,
                        st_telefone: this.value.cadastro.telefones.telefone,
                        st_celular: this.value.cadastro.telefones.celular, 
                        st_email: this.value.cadastro.st_email, 
                        ch_sexo: this.value.cadastro.ch_sexo, 
                    }
                })
                .then(res => { 
                    this.lista = res;
                }).finally(() => { 
                    this.$store.commit('loading', false);        
                });

            } else { 

                this.lista = [];
                this.entrar_cpf();

            }

        },

        entrar_cpf () { 
            if ( this.value.cadastro && this.value.cadastro.st_cpf ) { 
                if ( this.value.cadastro.st_cpf.length == 11 ) { 
                    this.validate = true;
                    this.pesquisar();
                }
            } else if ( this.value.paciente_unidade && this.value.paciente_unidade.st_sus ) { 
                if ( this.value.paciente_unidade.st_sus.length == 15 ) { 
                    this.validate = true;
                    this.pesquisar();
                }
            }
        },

        pesquisar () { 

            this.$store.commit('loading', true);        

            this.$util.loadItem(this, { 
                service: 'pacientes',
                func: 'checar_duplicidade',
                parms: { 
                    paciente: this.value
                },
            })
            .then(lista => { 
                this.lista = lista;
            })
            .finally(() => { 
                this.$store.commit('loading', false);        
            });

        }
    }

    
}
</script>